module.exports = __webpack_public_path__ + "static/media/logo_senko2.7873c12a.png";